var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frontend"},[_c('ProductsCreationUser',{attrs:{"product":_vm.product},on:{"changeCategory":_vm.changeCategoryProform,"createProduct":_vm.createProduct}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }